//* 组件库
import { UiModal } from "various-ui";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 响应式变量
    const refs = {
        id: ref<string>(""),
        status: ref<{ verify: string; forecast: string }>({ verify: "", forecast: "" }),
    };

    //* 节点
    const nodes = {
        modal: ref<InstanceType<typeof UiModal>>(),
    };

    //* 静态变量
    const variable = {
        timer: <NodeJS.Timeout | undefined>undefined,
    };

    //* 函数列表
    const methods = {
        //* 跳转函数
        next: () => open(routerResolve({ name: "MTHResult", params: { id: refs.id.value } }).href, "_blank"),

        //* 窗口激活函数
        open: (name: string, data: { mm_entrez: number; effect_size: number }[]) => {
            //* 窗口激活
            nodes.modal.value?.openModal();
            variable.timer = setTimeout(() => {
                //* 状态更新
                refs.status.value.verify = "run";
                //* 校验数据
                api.frontend("/api/ai/MTH/verify", {
                    data: { data },
                    error: () => (refs.status.value.verify = "error"),
                    method: "POST",
                    success: () => {
                        //* 状态更新
                        refs.status.value.verify = "success";
                        refs.status.value.forecast = "run";
                        //* 提交任务
                        api.frontend("/api/ai/MTH", {
                            data: { data, name },
                            error: () => (refs.status.value.forecast = "error"),
                            method: "POST",
                            success: (response) => {
                                if (!response) refs.status.value.forecast = "error";
                                else {
                                    //* 数据更新
                                    refs.id.value = response;
                                    //* 检查预测是否完成
                                    methods.run();
                                }
                            },
                        });
                    },
                });
            }, 300);
        },

        //* 运行函数
        run: () => {
            api.frontend("/api/ai/MTH", {
                data: { id: refs.id.value },
                error: () => (refs.status.value.forecast = "error"),
                success: (response) => {
                    //* 初始化数据
                    const state = response.state;
                    if (state == "SUCCESS") {
                        refs.status.value.forecast = "success";
                    } else if (state == "ENDING" || state == "FAILURE") {
                        refs.status.value.forecast = "error";
                    } else {
                        variable.timer = setTimeout(() => methods.run(), 500);
                    }
                },
            });
        },
    };

    //* 计算属性
    const computeds = {
        //* 提示文本
        message: computed(() => {
            if (refs.status.value.verify == "run") return i18n.t("CheckingTheData");
            else if (refs.status.value.verify == "error") return i18n.t("DataFormatError");
            else if (refs.status.value.verify == "success") {
                if (refs.status.value.forecast == "run") return i18n.t("ProcessingTheData");
                else if (refs.status.value.forecast == "error") {
                    return i18n.t("PredictionError");
                }
            }

            return "";
        }),

        //* 校验状态
        verify_status: computed(() => {
            if (refs.status.value.verify === "run") {
                return "refresh";
            } else if (refs.status.value.verify === "error") {
                return "error";
            } else {
                return "success";
            }
        }),

        //* 预测状态
        forecast_status: computed(() => {
            if (refs.status.value.forecast === "run") {
                return "refresh";
            } else if (refs.status.value.forecast === "error") {
                return "error";
            } else {
                return "success";
            }
        }),
    };

    return { refs, nodes, methods, variable, computeds };
};
